module.exports = __webpack_public_path__ + "static/media/tense-nervous.5ab62075.png";